import { render, staticRenderFns } from "./memberRestore.vue?vue&type=template&id=12f41b38&scoped=true"
import script from "./memberRestore.vue?vue&type=script&lang=js"
export * from "./memberRestore.vue?vue&type=script&lang=js"
import style0 from "./memberRestore.vue?vue&type=style&index=0&id=12f41b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f41b38",
  null
  
)

export default component.exports